import { ELocalUserAction, LocalUserAction } from "../actions/LocalUserActions";
import { RootState } from "./RootReducer";
import { UserCredential } from "../../Model/User";
import UserCredentialUtil from "../../Utility/UserCredentialUtil";

type LocalUser = {
  userCredential: UserCredential | null;
  isActive: boolean
}

const initialState: LocalUser = {
  userCredential: UserCredentialUtil.getUserCredential(),
  isActive: true,
}

export function localUserReducer(state = initialState, action: LocalUserAction): LocalUser {
  switch (action.type) {
    case ELocalUserAction.SAVE_USER: {
      UserCredentialUtil.setUserCredential(action.user);
      return {
        ...state,
        userCredential: action.user
      };
    }
    case ELocalUserAction.ONCHANGE_USER: {
      const user = UserCredentialUtil.getUserCredential();
      return {
        ...state,
        userCredential: user,
      };
    }
    case ELocalUserAction.DELETE_USER: {
      UserCredentialUtil.deleteUserCredential();
      return {
        ...state,
        userCredential: null,
      };
    }
    case ELocalUserAction.UPDATE_USER_ACTIVE: {
      return {
        ...state,
        isActive: action.isActive,
      };
    }
    default:
      return state;
  }
}

export const getUserCredential = (state: RootState) => state.localUserStore.userCredential;
export const isUserCredentialActive = (state: RootState) => state.localUserStore.isActive;